<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="text-left">
                <inter-card>
                    <p>Seguendo le indicazioni sar&agrave; possibile inserire una nuova richiesta di acquisto biglietti convenzionati per una partita, che dovr&agrave; essere selezionata nell'apposita sezione.<br /><br /><strong>Per partecipare sar&agrave; necessario che il numero di adulti sia minore o uguale al numero dei ragazzi minori di 18 anni Il numero minimo di partecipanti varia da 10 a 15 persone</strong>.<br /><br />Una volta inserita la richiesta sar&agrave; possibile modificarla fino ad avvenuto pagamento, che dovr&agrave; essere effettuato tramite bonifico bancario entro e non oltre la data indicata. Non sar&agrave; possibile apportare variazioni oltre la dead line comunicata o in caso di pagamento già avvenuto.<br /><br />I biglietti verranno caricati sul portale non appena ricevuto il pagamento e sarà possibile scaricarli dall'apposita area del vostro profilo in formato PDF.</p>
                </inter-card>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterCard from "../../../../components/card/InterCard";
    export default {
        name: "SocietyMatchWizardsStepOne",
        components: {InterCard}
    }
</script>

<style scoped>

</style>
